import UploadProductImage from "./UploadProductImage";

export default UploadProductImage;
